import { useTranslation } from 'react-i18next';
import type { IDisplayStatus } from '../model/displayStatus';
import { Pill } from '@components/ui/Pill/Pill';
import styles from './StatusPill.module.css';
export interface IStatusPillProps { status: IDisplayStatus }
export function StatusPill({ status }: IStatusPillProps) {
  const { t } = useTranslation();
  return (
    <Pill className={styles[`tone_${status.tone}`]}>
      {t(status.labelKey, status.days != null ? { days: status.days } : undefined)}
    </Pill>
  );
}
